import React from 'react'
import styles from './Footer.module.scss'
import Logo from '../../Basics/Logo/Logo'
import { Link } from 'react-router-dom'
import FooterNavigation from '../Navigation/FooterNavigation'

export default function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.footer__container}>
        <div className={styles.footer__section}>
          <Logo />
          <div className={styles.footer__socials}>
            <Link to="https://www.facebook.com/p/RFC-Doggen-100057054506591/" target="_blank">
              <img src="/assets/images/facebook.svg" alt="Facebook" />
            </Link>
            <Link to="https://www.instagram.com/fcdoggenerembodegem/" target="_blank">
              <img src="/assets/images/instagram.svg" alt="Instagram" />
            </Link>
          </div>
        </div>
        <div className={styles.footer__section}>
          <h3>Sitemap</h3>
          <FooterNavigation addClassName={styles.footer__sitemap} />
        </div>
        <div className={styles.footer__section}>
          <h3>Links</h3>
          <div className={styles.footer__links}>
            <Link className={styles.footer__link} to="https://www.rbfa.be/" target="_blank">
              <img src="/assets/images/rbfa.svg" alt="RBFA" />
            </Link>
            <Link className={styles.footer__link} to="https://www.voetbalvlaanderen.be/" target="_blank">
              <img src="/assets/images/voetbal-vlaanderen.svg" alt="Voetbal Vlaanderen" />
            </Link>
            <Link className={styles.footer__link} to="https://www.aalst.be/" target="_blank">
              <img src="/assets/images/stad-aalst.svg" alt="Stad Aalst" />
            </Link>
          </div>
        </div>
        <div className={styles.footer__section}>
          <div className={styles.footer__info}>
            <h3>FC Doggen Erembodegem</h3>
            <p>Resschebeke 50, 9320 Erembodegem</p>
            <div>
              <p>Lokaal (Café Sint Jans-Kring, Bij Bartje):</p>
              <p>Rerum Novarumstraat 4, 9300 Aalst</p>
            </div>
            <div>
              <p>GC + Secretaris:</p>
              <Link to='mailto:rene.vdb@proximus.be'>rene.vdb@proximus.be</Link>
            </div>
          </div>
          <div className={styles.footer__copyright}>
            <p>© F.C. Doggen Erembodegem</p>
            <p>Made with passion by <Link className={styles.benoit} to='https://benoitbiraguma.onrender.com' target='_blank'>benoitbiraguma</Link> </p>
          </div>
        </div>
      </div>
    </footer>
  )
}
